import { useCallback, useMemo } from "react"
import { useAppDispatch, useAppSelector } from "../../store"
import { type Session } from "../session/slice"
import { connect as connectAction, disconnect as disconnectAction, emit as emitAction, Realtime_item, reset_event, signout_all as signoutAllAction } from "./slice"

export function useStoreRealtime() {
  const dispatch = useAppDispatch()
  const value = useAppSelector(state => state.realtime_slice.value)

  const reset = useCallback((key: Realtime_item) => {
    dispatch(reset_event({ key }))
  }, [dispatch])

  const connect = useCallback((key: Realtime_item) => {
    dispatch(connectAction({ key }))
    reset(key)
  }, [dispatch, reset])

  const status = useCallback((key: Realtime_item) => {
    return value[key].status
  }, [value])

  const disconnect = useCallback((key: Realtime_item) => {
    dispatch(disconnectAction({ key }))
    reset(key)
  }, [dispatch, reset])

  const emit = useCallback((key: Realtime_item, event: string, data: any) => {
    dispatch(emitAction({ key, event, data }))
    reset(key)
  }, [dispatch, reset])

  const signin = useCallback((key: Realtime_item, data: Session) => {
    dispatch(emitAction({ key, event: "signin", data }))
    reset(key)
  }, [dispatch, reset])

  const signout = useCallback((key: Realtime_item, data: Session) => {
    dispatch(emitAction({ key, event: "signout", data }))
    reset(key)
  }, [dispatch, reset])

  const signout_all = useCallback((data: Session) => {
    dispatch(signoutAllAction(data))
  }, [dispatch])

  return useMemo(() => ({
    connect,
    status,
    disconnect,
    emit,
    signin,
    signout,
    signout_all
  }), [connect, status, disconnect, emit, signin, signout, signout_all])
}